<template>
  <div class="column is-9">
    <div class="div-table">
      <div class="columns is-gapless is-flex">
        <div class="column is-3 card-header has-text-centered">
          <strong class="is-size-7-touch">AHL#</strong>
        </div>
        <div class="column is-3 card-header has-text-centered">
          <strong class="is-size-7-touch">Name</strong>
        </div>
        <div class="column is-3 card-header has-text-centered">
          <strong class="is-size-7-touch">Handle</strong>
        </div>
        <div class="column is-3 card-header has-text-centered">
          <strong class="is-size-7-touch">Location</strong>
        </div>
      </div>
      <div class="columns is-gapless is-flex">
        <div class="column is-3 has-text-centered">
          <span class="has-text-danger is-size-7">{{ player.general.ahlid }}</span>
        </div>

        <div class="column is-3 has-text-centered">
          <span class="is-size-7">{{ player.general.name }}</span>
        </div>

        <div class="column is-3 has-text-centered">
          <span class="is-size-7">{{ player.general.handle }}</span>
        </div>

        <div class="column is-3 has-text-centered">
          <span class="is-size-7">{{ player.general.state }}</span>
        </div>
      </div>
      <div class="columns is-gapless">
        <div class="column is-12 has-text-centered">
          <span class="is-size-7 has-text-info">Compare points against another player.</span>
          <div class="columns">
            <div class="column is-half no-bordered game-search">
              <div class="field has-addons">
                <div class="control">
                  <input
                    v-model="comparison"
                    class="input is-small"
                    type="text"
                    placeholder="AHL#"
                    @keyup.enter="compare()"
                  >
                </div>
                <div
                  class="control"
                  @click="compare()"
                >
                  <a class="button is-black is-small">
                    <div class="is-pulled-right">Compare</div>
                    <span class="icon is-right">
                      <i class="far fa-search" />
                    </span>
                  </a>
                </div>
              </div>
            </div>
            <div class="column is-half">
              <a
                class="button is-info is-small"
                @click="addFriend(player.general.ahlid)"
              >
                <div class="is-pulled-right">Add to Friends list</div>
                <span class="icon is-right">
                  <i class="far fa-user-plus" />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    props: ['player', 'user', 'token'],
    data () {
      return {
        comparison: ''
      }
    },
    methods: {
      compare () {
        this.$emit('compare', this.comparison)
      },
      addFriend (id) {
        this.$axios({
          method: 'POST',
          url: `member/addfriend/${this.token}/${id}`,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data: {
            token: this.token || ''
          }
        })
          .then((res) => {
            this.$emit('message',
              {
                showDialog: true,
                error: false,
                message: res.data.message
              })
          })
          .catch((error) => {
            this.$emit('message',
              {
                showDialog: true,
                error: true,
                message: error.response.data.message
              })
          })
      }
    }
  }
</script>
